import { Box, Flex } from '@chakra-ui/react'
import type { ChakraComponent } from '@chakra-ui/react'

export const SingleLocationAsideItem: ChakraComponent<'div'> = ({
	children,
}) => {
	return (
		<Box
			bg="white"
			borderRadius="base"
			height="min-content"
			border="1px"
			borderColor="grey.100"
			shadow="xl"
			py={7}
			px={6}
			mb={5}
		>
			{children}
		</Box>
	)
}

export const SingleLocationAside: ChakraComponent<'aside'> = ({
	children,
	...props
}) => {
	return (
		<Flex
			as="aside"
			gridArea="5 / 2 / 6 / 3"
			order="unset"
			position="sticky"
			top={{ base: 'auto', lg: 3 }}
			bottom={{ base: 0, lg: 'auto' }}
			height="min-content"
			bg="white"
			{...props}
		>
			{children}
		</Flex>
	)
}
